/**
 * Validates a Czech birth number (rodné číslo).
 * Accepted formats: YYMMDD/NNNN  or  YYMMDDNNNN  (9 or 10 digits without slash)
 * Returns an error message string, or null if valid.
 */
export function validateCzPersonalId(value: string): string | null {
  if (!value) return null

  const digits = value.replace('/', '').replace(/\s/g, '')

  if (!/^\d{9,10}$/.test(digits)) {
    return 'Rodné číslo musí mít 9 nebo 10 číslic (formát RRMMDD/NNNN)'
  }

  const mm = parseInt(digits.substring(2, 4), 10)
  const dd = parseInt(digits.substring(4, 6), 10)

  // Month: 1–12 for men, 51–62 for women; some cases +20 for disambiguation
  const month = mm > 70 ? mm - 70 : mm > 50 ? mm - 50 : mm
  if (month < 1 || month > 12) {
    return 'Rodné číslo — neplatný měsíc'
  }

  if (dd < 1 || dd > 31) {
    return 'Rodné číslo — neplatný den'
  }

  // 10-digit numbers (born from 1.1.1954) must be divisible by 11
  if (digits.length === 10) {
    const num = parseInt(digits, 10)
    if (num % 11 !== 0) {
      return 'Rodné číslo — neplatná kontrolní číslice'
    }
  }

  return null
}

/**
 * Formats a Czech birth number for display (adds slash after 6 digits if missing).
 */
export function formatCzPersonalId(value: string): string {
  const digits = value.replace('/', '').replace(/\s/g, '')
  if (digits.length > 6) {
    return digits.substring(0, 6) + '/' + digits.substring(6)
  }
  return digits
}
